<template>
  <div>
    <job-filters/>

    <organization-form :loading="loading" @submit="createOrganization"></organization-form>
  </div>
</template>
<script>
  import JobFilters from '@/views/admin/jobs/JobFilters'
  import OrganizationForm from './OrganizationForm'
  import OrganizationService from 'src/services/OrganizationService'
  export default {
    name: 'organization-create',
    components: {
      JobFilters,
      OrganizationForm
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async createOrganization({ model }) {
        try {
          this.loading = true
          let { data } = await OrganizationService.create(model)
          let { id } = data
          this.$router.push(`/organizations/${id}`)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style>
</style>
